module.exports = __webpack_public_path__ + "assets/img/wallet-icon2.d11ad200.png";